import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AddOtherSupportingPartiesData,
  GetOneOtherSupportingParties,
  restValidateOtherSupportingParties,
  UpdateOtherSupportingParties,
  ValidateOtherSupportingParties,
} from "../../../../Redux/Reducers/Submitter/OtherSupportingParties";
import $ from "jquery";
import Swal from "sweetalert2";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import { GetAllSupportType } from "../../../../Redux/Reducers/Submitter/OtherSupportingParties/SupportTypedDropDown";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";

const AddEditOtherSupport = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      DropDownSupportType: state.DropDownSupportType.DropDownSupportType,
      OneOtherSupportingParties:
        state.OneOtherSupportingParties.OneOtherSupportingParties,
      loadingOneOtherSupportingParties:
        state.OneOtherSupportingParties.loadingOneOtherSupportingParties,

      OtherSupportingPartiesValidate:
        state.OneOtherSupportingParties.OtherSupportingPartiesValidate,
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
    };
  });

  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );

  useEffect(() => {
    dispatch(GetAllSupportType());
  }, []);
  //console.log(
  //   state.tE_MAinTeamMembersPreviousExperiencePartnershipsId,
  //   "state"
  // );

  const [OtherSupport, setOtherSupport] = useState({
    otherSupportingPartiesId:
      state.OneOtherSupportingParties?.otherSupportingPartiesId,
    supportingPartyName: state.OneOtherSupportingParties?.supportingPartyName,
    durationInMonths: state.OneOtherSupportingParties?.durationInMonths,
    supportTypeId: state.OneOtherSupportingParties?.supportTypeId,
    supportValue: state.OneOtherSupportingParties?.supportValue,
    supportCoverage: state.OneOtherSupportingParties?.supportCoverage,
    applicationInformationId:
      state.OneOtherSupportingParties?.applicationInformationId,
  });

  const numberWithCommas = (x) => {
    x = x != undefined ? x : "";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Function to add new AddSummaryEx

  const AddOther = async () => {
    const validationList = await dispatch(
      ValidateOtherSupportingParties({
        supportingPartyName: OtherSupport.supportingPartyName,
        durationInMonths: OtherSupport.durationInMonths,
        supportTypeId: OtherSupport.supportTypeId,
        supportValue: OtherSupport.supportValue,
        supportCoverage: OtherSupport.supportCoverage,
      })
    );
    //console.log(validationList, validationList.payload.length, "bnbnmbnmb");

    if (validationList.payload.length === 0) {
      // If validation passes, add new ExperienceSummary

      await dispatch(
        AddOtherSupportingPartiesData({
          applicationInformationId: OtherSupport.applicationInformationId,
          durationInMonths: OtherSupport.durationInMonths,
          supportCoverage: OtherSupport.supportCoverage,
          supportTypeId: OtherSupport.supportTypeId,
          supportValue: OtherSupport.supportValue,
          supportingPartyName: OtherSupport.supportingPartyName,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  useEffect(() => {
    dispatch(restValidateOtherSupportingParties());
  }, []);

  const UpdateOther = async () => {
    // Function to update existing sponsor data

    const validationList = await dispatch(
      ValidateOtherSupportingParties({
        supportingPartyName: OtherSupport.supportingPartyName,
        durationInMonths:
          OtherSupport.durationInMonths == ""
            ? null
            : OtherSupport.durationInMonths,
        supportTypeId: OtherSupport.supportTypeId,
        supportValue:
          OtherSupport.supportValue == "" ? null : OtherSupport.supportValue,
        supportCoverage: OtherSupport.supportCoverage,
      })
    );
    // If validation passes, update ExperienceSummary

    if (validationList.payload.length === 0) {
      await dispatch(
        UpdateOtherSupportingParties({
          applicationInformationId: OtherSupport.applicationInformationId,
          durationInMonths: OtherSupport.durationInMonths,
          otherSupportingPartiesId: OtherSupport.otherSupportingPartiesId,
          supportCoverage: OtherSupport.supportCoverage,
          supportTypeId: OtherSupport.supportTypeId,
          supportValue: OtherSupport.supportValue,
          supportingPartyName: OtherSupport.supportingPartyName,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  // Fetch additional ExperienceSummary data if props are provided
  useEffect(() => {
    if (props != null) {
      dispatch(GetOneOtherSupportingParties(props.otherSupportingPartiesId));
    }
  }, [props.otherSupportingPartiesId]);
  useEffect(() => {
    if (
      !state.loadingOneOtherSupportingParties &&
      Object.keys(props).length != 0
    ) {
      setOtherSupport({
        ...state.OneOtherSupportingParties,
      });
    } else {
      setOtherSupport({
        applicationInformationId: null,
        durationInMonths: null,
        supportCoverage: null,
        supportTypeId: null,
        supportValue: null,
        supportingPartyName: null,
        applicationInformationId:
          state.ApplicationInformation?.applicationInformationId,
      });
    }
  }, [state.OneOtherSupportingParties]);

  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  return (
    <>
      {!state.loadingOneOtherSupportingParties ? (
        <>
          <div className="AddEdite">
            <TextAreaAHSF
              fieldsName="SupportingPartyName"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setOtherSupport({
                  ...OtherSupport,
                  supportingPartyName: e.target.value,
                });
              }}
              defaultValue={OtherSupport?.supportingPartyName}
              showValidationMessage={
                state.OtherSupportingPartiesValidate
                  ? state.OtherSupportingPartiesValidate.includes(
                      "SupportingPartyName"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="DurationInMonths"
              show={true}
              disabled={shouldDisableFields}
              type={"number"}
              onChange={(e) => {
                setOtherSupport({
                  ...OtherSupport,
                  durationInMonths: e.target.value,
                });
              }}
              defaultValue={state.OneOtherSupportingParties?.durationInMonths}
              showValidationMessage={
                state.OtherSupportingPartiesValidate
                  ? state.OtherSupportingPartiesValidate.includes(
                      "DurationInMonths"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <AllDropDownsAHSF
              fieldsName="SupportType"
              show={true}
              disabled={shouldDisableFields}
              KeyText={"supportTypeName"}
              KeyValue={"supportTypeId"}
              arrayOoptionList={state.DropDownSupportType}
              dropdownType={"normal"}
              onChange={(e) => {
                setOtherSupport({
                  ...OtherSupport,
                  supportTypeId: e.target.value,
                });
              }}
              defaultValue={OtherSupport?.supportTypeId}
              showValidationMessage={
                state.OtherSupportingPartiesValidate
                  ? state.OtherSupportingPartiesValidate.includes("SupportType")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="SupportValue"
              show={true}
              disabled={shouldDisableFields}
              // type={"number"}
              comma={true}
              onChange={(e) => {
                setOtherSupport({
                  ...OtherSupport,
                  supportValue:
                    e.target.value === "" ? null : Number(e.target.value),
                });
              }}
              defaultValue={numberWithCommas(
                state.OneOtherSupportingParties?.supportValue
              )}
              showValidationMessage={
                state.OtherSupportingPartiesValidate
                  ? state.OtherSupportingPartiesValidate.includes(
                      "SupportValue"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="SupportCoverage"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setOtherSupport({
                  ...OtherSupport,
                  supportCoverage: e.target.value,
                });
              }}
              defaultValue={OtherSupport?.supportCoverage}
              showValidationMessage={
                state.OtherSupportingPartiesValidate
                  ? state.OtherSupportingPartiesValidate.includes(
                      "SupportCoverage"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            {!shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit" ? UpdateOther() : AddOther();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneOtherSupportingParties} />
    </>
  );
};

export default AddEditOtherSupport;
